import React from 'react';
import FadeIn from '../ui/FadeIn';
import { useSiteInfo } from '../../context/SiteInfoContext';

const WelcomeSection = () => {
  const { siteInfo } = useSiteInfo();
  const aboutUs = siteInfo?.aboutUs;

  if (!aboutUs) {
    return null;
  }

  const { heading, paragraphs, features, imageUrl, experienceBadge } = aboutUs;

  return (
    <section className="welcome-section" id="about">
      <div className="container">
        <div className="welcome-content">
          <FadeIn>
            <div className="welcome-text">
              <h2>{heading}</h2>
              {paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              <ul className="features-list">
                {features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
            </div>
          </FadeIn>
          <FadeIn>
            <div className="welcome-image">
              <img
                src={imageUrl}
                alt="JAC Cars forecourt"
                loading="lazy"
              />
              <div className="experience-badge">
                <span className="number">{experienceBadge.number}</span>
                <span className="text">{experienceBadge.text}</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
